import React, { useContext, useEffect, useReducer, useState } from "react";
import Badge from "react-bootstrap/esm/Badge";
import Button from "react-bootstrap/esm/Button";
import Col from "react-bootstrap/esm/Col";
import ListGroup from "react-bootstrap/esm/ListGroup";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import CategoryList from "../components/CategoryList";
import CategoryListGrid from "../components/CategoryListGrid";
import FeaturesList from "../components/FeaturesList";
import LoadingBox from "../components/LoadingBox";
import ProductAra from "../components/ProductAra";
import ProductsList from "../components/ProductsList";
import ProductsListGrid from "../components/ProductsListGrid";
import SepeteEkleList from "../components/SepeteEkleList";
import TableButtonSmall from "../components/TableButtonSmall";
import TableDescription from "../components/TableDescription";
import TableExchange from "../components/TableExchange";
import Tables from "../components/Tables";
import useAxios from "../hooks/useAxios";
import useCompartments from "../hooks/useCompartments";
import useProductsAndCategories from "../hooks/useProductsAndCategories";
import useUsers from "../hooks/useUsers";
import { getError } from "../utils";
import CartScreenTouch from "./CartScreenTouch";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default function CategoricOrderScreen() {
  const axios = useAxios();
  useUsers();
  const [{ loading }] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    carts,
    table,
    mostUsedProducts,
    products,
    categories,
    allCategories,
    users = [],
  } = state;
  const compartments = state.compartments || [];
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const smallComputer = useMediaQuery({ query: "(max-width: 1350px)" });

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const rootCategory = sp.get("rootCategory") || "";
  const navigate = useNavigate();
  const [selectedCompartment, setSelectedCompartment] = useState(null);
  const [showEnterDescription, setShowEnterDescription] = useState(false);
  const [tableCompartment, setTableCompartment] = useState(null);
  const [showCategories, setShowCategories] = useState(false);
  const [mostUsedProductsFiltered, setMostUsedProductsFiltered] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [tableCompartmentProducts, setTableCompartmentProducts] = useState([]);
  const [tableTemp, setTableTemp] = useState(table);
  const [tablePage, setTablePage] = useState(0);
  const [isGridView, setIsGridView] = useState(false);
  const [tableSelectedFromMain, setTableSelectedFromMain] = useState(false);
  const [queryByName, setQueryByName] = useState("");
  const [showTableExchange, setShowTableExchange] = useState(false);
  const [reportDate, setReportDate] = useState();
  const [reportDanger, setReportDanger] = useState(false);

  const [features, setFeatures] = useState([]);
  const [feature, setFeature] = useState("");
  const [product, setProduct] = useState("");
  const [cartsOrdered, setCartsOrdered] = useState([]);

  const resetToHead = () => {
    setFeature("");
    setFeatures([]);
    setProduct("");
    setQueryByName("");
  };

  useEffect(() => {
    setTableTemp(table);
  }, [table]);

  useCompartments();

  const [loadingProductsAndCategories, , ,] = useProductsAndCategories();

  useEffect(() => {
    const mostUsedFiltered =
      tableCompartment &&
      tableCompartment.categories &&
      tableCompartment.categories.length > 0 &&
      tableCompartmentProducts.length > 0
        ? mostUsedProducts.filter((m) =>
            tableCompartmentProducts.includes(m._id)
          )
        : mostUsedProducts;

    setMostUsedProductsFiltered(mostUsedFiltered || []);
  }, [tableCompartment, tableCompartmentProducts, mostUsedProducts]);

  const tablePageLeftHandler = () => {
    if (tablePage > 0) {
      setTablePage(tablePage - 1);
    }
  };

  const tablePageRightHandler = () => {
    if (tablePage < 3) {
      setTablePage(tablePage + 1);
    }
  };

  useEffect(() => {
    const founds = compartments
      .filter((c) => c.status)
      .filter((c) => tableTemp >= c.startNum && tableTemp <= c.endNum);
    if (founds.length > 0) {
      setTableCompartment(founds[0]);
      if (founds[0].categories && founds[0].categories.length > 0) {
        setTableCompartmentProducts(
          founds[0].categories
            .flatMap((c) => c.products)
            .filter((value, index, array) => array.indexOf(value) === index)
        );
      }
    }
  }, [tableTemp]);

  useEffect(() => {
    if (queryByName) {
      let queryProducts = isNaN(queryByName)
        ? products.filter((p) =>
            p.name.toLowerCase().includes(queryByName.toLowerCase())
          )
        : products.filter((p) => p.no === Number(queryByName));

      queryProducts =
        tableCompartment &&
        tableCompartment.categories &&
        tableCompartment.categories.length > 0 &&
        tableCompartmentProducts.length > 0
          ? queryProducts.filter((m) =>
              tableCompartmentProducts.includes(m._id)
            )
          : queryProducts;

      setFilteredProducts(queryProducts);
      setFilteredCategories([]);
    } else {
      if (rootCategory) {
        const rootCategories = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].categories;
        const rootProducts = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].products;
        if (rootCategories.length > 0) {
          setFilteredCategories(rootCategories);
          setFilteredProducts([]);
        } else if (rootProducts.length > 0) {
          setFilteredProducts(rootProducts);
          setFilteredCategories([]);
        }
      } else {
        if (
          showCategories ||
          !mostUsedProducts ||
          mostUsedProducts.length === 0
        ) {
          setFilteredCategories(
            tableCompartment &&
              tableCompartment.categories &&
              tableCompartment.categories.length > 0
              ? tableCompartment.categories
              : categories
          );
          setFilteredProducts([]);
          //setShowCategories(true);
        } else {
          setFilteredProducts(mostUsedProductsFiltered);
          setFilteredCategories([]);
        }
      }
    }
  }, [
    mostUsedProductsFiltered,
    queryByName,
    products,
    categories,
    tableCompartment,
    tableCompartmentProducts,
    rootCategory,
    showCategories,
    mostUsedProducts,
    allCategories,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/api/categories/leafes/compartment`);

        ctxDispatch({
          type: "LEAF_CATEGORIES_UPDATED",
          payload: data || [],
        });
      } catch (err) {}
    };

    const leafCategories = localStorage.getItem("leafCategories")
      ? JSON.parse(localStorage.getItem("leafCategories"))
      : [];
    if (leafCategories.length === 0) {
      fetchData();
    }
  }, []);

  const fetchReportDate = async () => {
    try {
      const { data } = await axios.get(`/api/orders/reportdate`);
      setReportDate(new Date(data.reportDate));
      //setDontShowReportDate(data.waitNextDay);
      setReportDanger(data.danger);
    } catch (error) {
      toast(getError(error));
    }
  };

  useEffect(() => {
    fetchReportDate();
  }, []);

  useEffect(() => {
    const cartsOrders = carts.filter(
      (cart) =>
        cart && cart.cartItems.length > 0 && !cart.delivered && cart.alert
    );
    setCartsOrdered(cartsOrders);
  }, [carts]);

  useEffect(() => {
    cartsOrdered.forEach((c) => {
      c.cartItems.forEach((item) => {
        if (!item.delivered && item.alert && !item.alertPlayed) {
          var audio = new Audio("/ding.mp3");
          audio.play();
          ctxDispatch({
            type: "CARTITEM_SET_ALERT_PLAYED",
            payload: {
              tableNum: c.tableNum,
              itemCode: item.itemCode,
            },
          });
        }
      });
    });
  }, [cartsOrdered]);

  useEffect(() => {
    if (tableTemp && tableSelectedFromMain && !smallComputer) {
      ctxDispatch({
        type: "SELECT_TABLE",
        payload: tableTemp,
      });

      var elem = document.getElementById("tablePanel");
      elem.scrollTop =
        document.getElementById("tableButton" + tableTemp).offsetTop - 300;
      setTableSelectedFromMain(false);
    }
  }, [tableSelectedFromMain]);

  return (
    <div style={{ width: "100%" }}>
      <Helmet>
        <title>Sipariş Girişi</title>
      </Helmet>
      <Row>
        {tableTemp > 0 ? (
          <>
            <Col
              className="text-start"
              style={{ display: "flex", paddingLeft: "0px" }}
              md={7}
            >
              <ListGroup horizontal>
                <ListGroup.Item className="borderZero bg-dark">
                  <Link
                    className="textDecorationNone"
                    onClick={() => {
                      setQueryByName("");
                      setTableTemp(0);
                      ctxDispatch({ type: "SELECT_TABLE", payload: 0 });
                      setProduct("");
                      setFeature("");
                    }}
                    to=""
                  >
                    <Badge
                      className="border border-success p-2 px-3"
                      bg="dark text-success"
                      style={{ fontSize: "25px", position: "relative" }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "2px",
                          left: "2px",
                          fontSize: "12px",
                        }}
                      >
                        No
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          fontSize: "12px",
                          writingMode: "vertical-rl",
                        }}
                      >
                        {carts[tableTemp - 1].description?.substring(0, 5)}
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          bottom: "1px",
                          left: "2px",
                          fontSize: "11px",
                          fontFamily: "monospace",
                        }}
                      >
                        {users
                          .find(
                            (u) => u._id === carts[tableTemp - 1].onBusinessUser
                          )
                          ?.name.substring(0, 5)}
                      </div>

                      {table}
                    </Badge>
                  </Link>
                </ListGroup.Item>
                {tableTemp && (
                  <ListGroup.Item className="borderZero bg-dark">
                    <Link
                      to="/dailyReport"
                      className={
                        reportDanger
                          ? "textDecorationNone text-danger"
                          : "textDecorationNone text-success"
                      }
                    >
                      <h5 className="bg-dark">
                        <i className="far fa-clock"></i>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                )}
                {tableTemp && (
                  <ListGroup.Item className="borderZero bg-dark">
                    <Link
                      to="#"
                      className="textDecorationNone text-success"
                      onClick={() => {
                        setShowEnterDescription(true);
                      }}
                    >
                      <h5>
                        <i className="fa fa-file-text-o"></i>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                )}
                {tableTemp && (
                  <ListGroup.Item className="borderZero bg-dark">
                    <Link
                      to="#"
                      className="textDecorationNone text-success"
                      onClick={() => {
                        setShowTableExchange(true);
                      }}
                    >
                      <h5>
                        <i className="fas fa-exchange-alt"></i>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Col>{" "}
          </>
        ) : (
          <>
            <div
              style={{ display: "flex", flexDirection: "row" }}
              className="mt-4"
            >
              {reportDate &&
                (reportDanger ? (
                  <Link
                    to="/dailyReport"
                    className="textDecorationNone marginleft5 text-info"
                  >
                    <h5>
                      {reportDate.toLocaleDateString("tr-TR", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                      })}
                      &nbsp;
                      <i className="far fa-clock"></i>
                      <span className="text-bold text-danger">
                        &nbsp;Kapanış Yap!
                      </span>
                    </h5>
                  </Link>
                ) : (
                  <Link
                    to="/dailyReport"
                    className="textDecorationNone marginleft5"
                  >
                    <h5>
                      {reportDate.toLocaleDateString("tr-TR", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                      })}
                      &nbsp;
                      <i className="far fa-clock"></i>
                    </h5>
                  </Link>
                ))}

              {compartments && compartments.length > 1 && (
                <>
                  <Link
                    className="textDecorationNone marginleft5 ms-5 me-3"
                    to=""
                    onClick={() => {
                      setSelectedCompartment(null);
                    }}
                  >
                    <h5>
                      <i className="fas fa-angle-right text-secondary"></i>
                      <span
                        className={
                          !selectedCompartment
                            ? "text-primary"
                            : "text-secondary"
                        }
                      >
                        Tümü
                      </span>
                    </h5>
                  </Link>
                  {compartments
                    .filter((c) => c.status)
                    .map((c) => (
                      <Link
                        className="textDecorationNone me-3"
                        to=""
                        onClick={() => {
                          setSelectedCompartment(c);
                        }}
                        key={c._id}
                      >
                        <h5>
                          <i className="fas fa-angle-right text-secondary"></i>
                          <span
                            className={
                              selectedCompartment &&
                              selectedCompartment._id === c._id
                                ? "text-primary"
                                : "text-secondary"
                            }
                          >
                            {c.name}
                          </span>
                        </h5>
                      </Link>
                    ))}
                </>
              )}
            </div>
          </>
        )}
      </Row>

      <Row style={{ marginTop: "1rem" }}>
        {loading || loadingProductsAndCategories ? (
          <LoadingBox></LoadingBox>
        ) : (
          <>
            <Col
              md={table ? (smallComputer ? 5 : 7) : 12}
              style={{ padding: "0px" }}
            >
              <Row>
                {table ? (
                  <div className="d-flex">
                    {!smallComputer && (
                      <div
                        className=" border border-secondary rounded-start p-1 heightOfPanelNoOverflow"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          minWidth: "300px",
                        }}
                      >
                        {compartments && compartments.length > 1 && (
                          <div
                            className={
                              compartments.length > 2
                                ? "mt-1 mb-3 ps-1  pe-1"
                                : "mt-1 mb-2 ps-1  pe-1"
                            }
                          >
                            <div className="btn-group" role="group">
                              <Button
                                size={compartments.length > 2 ? "" : "lg"}
                                type="button"
                                variant={
                                  !selectedCompartment
                                    ? "primary"
                                    : "outline-secondary"
                                }
                                onClick={() => {
                                  setSelectedCompartment(null);
                                }}
                              >
                                {"Tümü"}
                              </Button>
                              {compartments
                                .filter((c) => c.status)
                                .map((c) => (
                                  <Button
                                    size={compartments.length > 2 ? "" : "lg"}
                                    type="button"
                                    variant={
                                      selectedCompartment &&
                                      selectedCompartment._id === c._id
                                        ? "primary"
                                        : "outline-secondary"
                                    }
                                    onClick={() => {
                                      setSelectedCompartment(c);
                                    }}
                                    key={c._id}
                                  >
                                    {c.name.substring(0, 6)}
                                  </Button>
                                ))}
                            </div>
                          </div>
                        )}

                        <div
                          id="tablePanel"
                          className="d-flex flex-wrap scrollbar scrollbar-primary"
                          style={{
                            overflow: "auto",
                            overflowX: "hidden",
                            height: "100%",
                            maxWidth: "510px",
                            justifyContent: "flex-start",
                            alignContent: "flex-start",
                          }}
                        >
                          {carts
                            .filter((c, i) =>
                              selectedCompartment
                                ? c.tableNum >= selectedCompartment.startNum &&
                                  c.tableNum <= selectedCompartment.endNum
                                : compartments && compartments.length > 0
                                ? c.tableNum <=
                                  compartments[compartments.length - 1].endNum
                                : c.tableNum <= 40
                            )
                            .map((c) => (
                              <div
                                key={c.tableNum}
                                id={"tableButton" + c.tableNum}
                              >
                                <TableButtonSmall
                                  cartItems={c.cartItems}
                                  cart={c}
                                  isSelected={c.tableNum === tableTemp}
                                  keyy={c.tableNum}
                                  tableNum={c.tableNum}
                                  tableMinWitdh={"80px"}
                                  tableTemp={tableTemp}
                                  setTableTemp={setTableTemp}
                                  ctxDispatch={ctxDispatch}
                                ></TableButtonSmall>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                    <div
                      className={`border border-white bg-dark ${
                        isTabletOrMobile
                          ? "rounded "
                          : "rounded-end heightOfPanelNoOverflow"
                      }`}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <ProductAra
                        queryByName={queryByName}
                        setQueryByName={setQueryByName}
                        setProduct={setProduct}
                        setFeature={setFeature}
                        setFeatures={setFeatures}
                        loading={loading}
                        navigate={navigate}
                        rootCategory={rootCategory}
                        showCategories={showCategories}
                        setShowCategories={setShowCategories}
                        setIsGridView={setIsGridView}
                        isGridView={isGridView}
                        filteredCategories={categories}
                      />
                      {features.length > 1 && !feature ? (
                        <FeaturesList
                          features={features}
                          product={product}
                          setFeature={setFeature}
                          setFeatures={setFeatures}
                          setProduct={setProduct}
                        />
                      ) : (product && product.features.length === 0) ||
                        (product && feature) ? (
                        <SepeteEkleList
                          tableNum={table}
                          feature={feature}
                          product={product}
                          setFeature={setFeature}
                          setFeatures={setFeatures}
                          setProduct={setProduct}
                          setQueryByName={setQueryByName}
                        />
                      ) : (filteredProducts && filteredProducts.length > 0) ||
                        !filteredCategories ||
                        filteredCategories.length === 0 ? (
                        !isGridView ? (
                          <ProductsList
                            products={filteredProducts}
                            setFeature={setFeature}
                            setFeatures={setFeatures}
                            setProduct={setProduct}
                            isTabletOrMobile={isTabletOrMobile}
                          />
                        ) : (
                          <ProductsListGrid
                            products={filteredProducts}
                            setFeature={setFeature}
                            setFeatures={setFeatures}
                            setProduct={setProduct}
                            isTabletOrMobile={isTabletOrMobile}
                          />
                        )
                      ) : filteredCategories &&
                        filteredCategories.length > 0 ? (
                        isGridView ? (
                          <CategoryListGrid
                            resetToHead={resetToHead}
                            categories={categories}
                          />
                        ) : (
                          <CategoryList
                            resetToHead={resetToHead}
                            categories={categories}
                          />
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ) : (
                  <Col md={12}>
                    <Tables
                      selectedCompartment={selectedCompartment}
                      compartments={compartments}
                      tablePageLeftHandler={tablePageLeftHandler}
                      tablePageRightHandler={tablePageRightHandler}
                      tablePage={tablePage}
                      setTableTemp={setTableTemp}
                      tableTemp={tableTemp}
                    ></Tables>
                  </Col>
                )}
              </Row>
            </Col>
            {table && (
              <Col
                md={smallComputer ? 7 : 5}
                style={{ padding: "0px", paddingLeft: "3px" }}
              >
                {tableTemp && (
                  <div className="d-flex">
                    <div
                      className="heightOfPanelForTouch"
                      style={{ width: "100%" }}
                    >
                      <CartScreenTouch
                        tableTemp={tableTemp}
                        isCustomerOrder={false}
                        height="100%"
                      ></CartScreenTouch>
                    </div>
                  </div>
                )}
              </Col>
            )}
          </>
        )}
      </Row>

      <TableExchange
        carts={carts}
        show={showTableExchange}
        setShow={setShowTableExchange}
        changeThisTableNum={tableTemp}
      />

      {showEnterDescription && (
        <TableDescription
          showEnterDescription={showEnterDescription}
          setShowEnterDescription={setShowEnterDescription}
          tableNum={tableTemp}
          alertTimePeriod={carts[tableTemp - 1]?.alertTimePeriod}
          onBusinessUser={carts[tableTemp - 1]?.onBusinessUser}
          tableType={carts[tableTemp - 1]?.tableType}
          alertOn={carts[tableTemp - 1]?.alertOn}
          description={carts[tableTemp - 1]?.description}
        />
      )}
    </div>
  );
}
